import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import classNames from 'classnames';
import { SkeletonBox } from '../../../SkeletonBox/SkeletonBox.es.js';
import { InputContext } from '../../Input.Context/Input.Context.es.js';
import { InputInlineAffix } from '../../Input.Inline/Input.Inline.Affix/Input.Inline.Affix.es.js';
import '../../Input.Inline/Input.Inline.Button/Input.Inline.Button.es.js';
import '../../Input.Inline/Input.Inline.Icon/Input.Inline.Icon.es.js';
import '../../Input.Inline/Input.Inline.IconButton/Input.Inline.IconButton.es.js';

const InputFieldButton = /*#__PURE__*/ forwardRef(({ className, children, focused, onChange, ...rest }, // Ref provided by react hook form or downshift
ref)=>{
    const { id, inputLabelId, inputMessageId, value, disabled, warning, error, loading, placeholder, display, labelProps, label } = useContext(InputContext);
    const fieldButtonCss = classNames('field-container', 'field-button', {
        'has-value': Boolean(value),
        error,
        focused,
        disabled,
        warning
    });
    return jsxs(Fragment, {
        children: [
            loading && jsx(SkeletonBox, {
                className: "field-button-loading"
            }),
            jsxs("button", {
                ref: ref,
                "aria-describedby": inputMessageId,
                "aria-labelledby": inputLabelId,
                className: fieldButtonCss,
                disabled: disabled,
                id: id,
                type: "button",
                ...rest,
                children: [
                    jsx("div", {
                        className: "field-content",
                        children: jsx("div", {
                            className: "field-display-value",
                            children: value ?? placeholder
                        })
                    }),
                    label && display === 'inline' && jsx(InputInlineAffix, {
                        intent: "label",
                        labelProps: labelProps,
                        variant: "prefix",
                        children: label
                    }),
                    children
                ]
            })
        ]
    });
});
InputFieldButton.displayName = 'Input.Field.Button';

export { InputFieldButton, InputFieldButton as default };
//# sourceMappingURL=Input.Field.Button.es.js.map
